"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../../constants/index.js");
var _index2 = require("../../helpers/index.js");
var _index3 = require("../../utils/index.js");
var _utils = require("./utils");
var _excluded = ["category", "contractLength", "deviceConfiguration", "deviceTradeInManufacturer", "deviceTradeInModel", "deviceStorage", "discount", "discountType", "dollarsAdded", "internalCampaignName", "isIncaClicks", "isIncaImpressions", "isOfferClicks", "isOfferImpressions", "isVisible", "listPrice", "name", "ngcOrderItemID", "offerCode", "offerOrderType", "offerRanking", "paymentAmount", "paymentType", "priceTotal", "prodDataAmount", "prodLanguage", "productBrand", "productColour", "productGenre", "productName", "productProvisioner", "productSize", "productStatus", "productType", "quantity", "servicePayment", "serviceTier", "shipping", "shipToHome", "shippingMethod", "sku", "soc", "subCategory", "subscriberPhoneNumber", "tags", "taxAmount"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var visibilityTypes = _index.eventFieldValues.visibilityTypes;
var stringField = _index2.formatters.stringField,
  numberField = _index2.formatters.numberField;

// Keys that cannot be customized since they have a default value or works with a custom behavior
var lockedFields = ['prodVisibility', 'promoCode'];
var getTemplate = function getTemplate() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    category = _ref.category,
    contractLength = _ref.contractLength,
    deviceConfiguration = _ref.deviceConfiguration,
    deviceTradeInManufacturer = _ref.deviceTradeInManufacturer,
    deviceTradeInModel = _ref.deviceTradeInModel,
    deviceStorage = _ref.deviceStorage,
    discount = _ref.discount,
    discountType = _ref.discountType,
    dollarsAdded = _ref.dollarsAdded,
    internalCampaignName = _ref.internalCampaignName,
    isIncaClicks = _ref.isIncaClicks,
    isIncaImpressions = _ref.isIncaImpressions,
    isOfferClicks = _ref.isOfferClicks,
    isOfferImpressions = _ref.isOfferImpressions,
    isVisible = _ref.isVisible,
    listPrice = _ref.listPrice,
    name = _ref.name,
    ngcOrderItemID = _ref.ngcOrderItemID,
    offerCode = _ref.offerCode,
    offerOrderType = _ref.offerOrderType,
    offerRanking = _ref.offerRanking,
    paymentAmount = _ref.paymentAmount,
    paymentType = _ref.paymentType,
    priceTotal = _ref.priceTotal,
    prodDataAmount = _ref.prodDataAmount,
    prodLanguage = _ref.prodLanguage,
    productBrand = _ref.productBrand,
    productColour = _ref.productColour,
    productGenre = _ref.productGenre,
    productName = _ref.productName,
    productProvisioner = _ref.productProvisioner,
    productSize = _ref.productSize,
    productStatus = _ref.productStatus,
    productType = _ref.productType,
    quantity = _ref.quantity,
    servicePayment = _ref.servicePayment,
    serviceTier = _ref.serviceTier,
    shipping = _ref.shipping,
    _ref$shipToHome = _ref.shipToHome,
    shipToHome = _ref$shipToHome === void 0 ? true : _ref$shipToHome,
    shippingMethod = _ref.shippingMethod,
    sku = _ref.sku,
    soc = _ref.soc,
    subCategory = _ref.subCategory,
    subscriberPhoneNumber = _ref.subscriberPhoneNumber,
    tags = _ref.tags,
    taxAmount = _ref.taxAmount,
    rest = _objectWithoutProperties(_ref, _excluded);
  var cleanedRest = (0, _index3.removeLockedKeys)(rest, lockedFields);
  var nameValue = stringField(name);
  var productNameValue = (0, _utils.formatProductName)(productName);
  var offerOrderTypeValue = stringField(offerOrderType);
  var internalCampaignNameValue = stringField(internalCampaignName);
  var campaignIndicators = [isIncaClicks, isIncaImpressions, isOfferClicks, isOfferImpressions];
  if (campaignIndicators.filter(Boolean).length === 1) {
    return (0, _utils.getCampaign)({
      internalCampaignName: internalCampaignNameValue,
      isIncaClicks: isIncaClicks,
      isIncaImpressions: isIncaImpressions,
      isOfferClicks: isOfferClicks,
      isOfferImpressions: isOfferImpressions,
      offerCode: stringField(offerCode),
      offerOrderType: offerOrderTypeValue,
      offerRanking: offerRanking,
      ngcOrderItemID: ngcOrderItemID,
      subscriberPhoneNumber: subscriberPhoneNumber
    });
  }
  var skuValue = sku;
  var prodVisibility = isVisible ? visibilityTypes.VISIBLE : visibilityTypes.HIDDEN;
  var productQuantity = numberField(quantity);
  var productValues = (0, _utils.getProductValues)(tags);
  return {
    SKU: skuValue,
    name: nameValue || productNameValue,
    priceTotal: numberField(priceTotal),
    quantity: productQuantity,
    _telus: _objectSpread({
      productName: productNameValue,
      category: stringField(category) || (productValues === null || productValues === void 0 ? void 0 : productValues.category),
      subCategory: stringField(subCategory) || (productValues === null || productValues === void 0 ? void 0 : productValues.subCategory),
      productType: stringField(productType) || (productValues === null || productValues === void 0 ? void 0 : productValues.productType),
      soc: stringField(soc),
      listPrice: {
        amount: numberField(listPrice)
      },
      paymentAmount: {
        amount: numberField(paymentAmount)
      },
      shipping: {
        amount: numberField(shipping)
      },
      discount: {
        amount: numberField(discount)
      },
      taxAmount: {
        amount: numberField(taxAmount)
      },
      contractLength: contractLength === null || contractLength === void 0 ? void 0 : contractLength.toString(),
      deviceConfiguration: stringField(deviceConfiguration),
      deviceTradeInManufacturer: stringField(deviceTradeInManufacturer),
      deviceTradeInModel: stringField(deviceTradeInModel),
      deviceStorage: stringField(deviceStorage),
      discountType: stringField(discountType),
      dollarsAdded: {
        amount: numberField(dollarsAdded)
      },
      ngcOrderItemID: ngcOrderItemID,
      internalCampaignName: internalCampaignNameValue,
      offerOrderType: offerOrderTypeValue,
      paymentType: stringField(paymentType),
      prodDataAmount: stringField(prodDataAmount),
      prodLanguage: stringField(prodLanguage),
      prodVisibility: typeof isVisible === 'boolean' ? prodVisibility : undefined,
      productBrand: stringField(productBrand),
      productColour: stringField(productColour),
      productGenre: stringField(productGenre),
      productProvisioner: stringField(productProvisioner),
      productSize: stringField(productSize),
      productStatus: stringField(productStatus),
      servicePayment: stringField(servicePayment),
      serviceTier: stringField(serviceTier),
      shipToHome: shipToHome,
      shippingMethod: stringField(shippingMethod),
      subscriberPhoneNumber: subscriberPhoneNumber,
      unitsAdded: productQuantity === null || productQuantity === void 0 ? void 0 : productQuantity.toString()
    }, cleanedRest)
  };
};
var _default = exports["default"] = getTemplate;